// Patronato → INPS: tutte le pratiche INPS in un'unica pagina (riquadri con quante sono e quante da fare).
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Landmark, ChevronRight, FileText } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/caf/inps/riepilogo`;
// elenco fisso: i riquadri si vedono sempre; i numeri arrivano dal server
const PRATICHE = [
  ['naspi', 'NASpI'], ['assegno_unico', 'Assegno Unico'], ['maternita_inps', 'Maternità INPS'], ['bonus_nido', 'Bonus nido INPS'],
  ['assegno_sociale', 'Assegno sociale'], ['assegno_invalidita', 'Assegno ordinario di invalidità'],
  ['assegno_invalidita_civile', 'Assegno di invalidità civile'], ['pensione_invalidita_civile', 'Pensione di invalidità civile'],
  ['indennita_frequenza', 'Indennità di frequenza'], ['bonus_nuovi_nati', 'Bonus nuovi nati'], ['bonus_mamme', 'Bonus mamme'],
  ['assegno_inclusione', 'Assegno di inclusione (ADI)'],
].map(([tipo, nome]) => ({ tipo, nome, percorso: `/patronato/${tipo.replace(/_/g, '-')}` }));

export default function PatronatoInps() {
  const [conteggi, setConteggi] = useState({});
  useEffect(() => {
    axios.get(API).then((r) => setConteggi(Object.fromEntries(r.data.pratiche.map((p) => [p.tipo, p])))).catch(() => {});
  }, []);
  const pratiche = PRATICHE.map((p) => ({ ...p, ...(conteggi[p.tipo] || {}) }));
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-indigo-100 text-indigo-700 flex items-center justify-center"><Landmark className="w-5 h-5" /></div>
        <div>
          <h1 className="text-2xl font-bold">INPS</h1>
          <p className="text-sm text-slate-500">Pratiche INPS del Patronato</p>
        </div>
      </div>
      {(
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {pratiche.map((p) => (
            <Link key={p.tipo} to={p.percorso}>
              <Card className="hover:shadow-md hover:border-indigo-300 transition-all h-full">
                <CardContent className="p-4 flex items-center gap-3">
                  <FileText className="w-5 h-5 text-indigo-600 shrink-0" />
                  <div className="flex-1 min-w-0">
                    <div className="font-semibold truncate">{p.nome}</div>
                    <div className="text-sm text-slate-500">{p.tutte === undefined ? 'Apri' : `${p.tutte} pratiche`}{p.da_fare > 0 && <span className="text-amber-700 font-medium"> · {p.da_fare} da fare</span>}</div>
                  </div>
                  <ChevronRight className="w-4 h-4 text-slate-400" />
                </CardContent>
              </Card>
            </Link>
          ))}
          <Link to="/estratto-inps">
            <Card className="hover:shadow-md hover:border-indigo-300 transition-all h-full">
              <CardContent className="p-4 flex items-center gap-3">
                <FileText className="w-5 h-5 text-indigo-600 shrink-0" />
                <div className="flex-1 min-w-0">
                  <div className="font-semibold truncate">Estratto contributivo INPS</div>
                  <div className="text-sm text-slate-500">Lettura estratti conto contributivi</div>
                </div>
                <ChevronRight className="w-4 h-4 text-slate-400" />
              </CardContent>
            </Card>
          </Link>
        </div>
      )}
    </div>
  );
}
